import dayjs from 'dayjs';

// A link expiring within this window is offered for extension.
const EXPIRING_WITHIN_MONTHS = 1;

const isUnexpired = (expiry: string | Date | undefined, now: Date) => !!expiry && new Date(expiry) > now;

const isExpiringSoon = (expiry: string | Date | undefined, now: Date) =>
  isUnexpired(expiry, now) && new Date(expiry as string | Date) <= dayjs(now).add(EXPIRING_WITHIN_MONTHS, 'month').toDate();

// The contact's unexpired access token, from the token list first, then the legacy single-token fields.
export const getValidToken = (contact: IPlayerContact, now: Date = new Date()): string | null => {
  const listed = (contact.contactAccessTokens || []).find(token => token.token && isUnexpired(token.expiry, now));
  if (listed) return listed.token;

  if (contact.reportCardAccessToken && isUnexpired(contact.reportCardAccessExpiry, now)) {
    return contact.reportCardAccessToken;
  }
  return null;
};

// Only links issued for this player assessment count: they are the ones "Extend link expiry" moves.
export const hasExpiringTokens = (contacts: IPlayerContact[], playerAssessmentId: string, now: Date = new Date()): boolean =>
  contacts.some(contact => (contact.contactAccessTokens || [])
    .some(token => token.playerAssessmentId === playerAssessmentId && isExpiringSoon(token.expiry, now)));
